import React from "react"

const GroupsDisplay = ({ groups }) => <span>{groups.map(({ name }) => name).join(", ")}</span>

export { GroupsDisplay }
